import { z } from 'zod'

// Org-level quotes settings, stored as system-preference JSON under
// QUOTES_SETTINGS_KEYS (same storage pattern as invoice-settings).

export const QUOTES_SETTINGS_KEYS = {
  SETTINGS: 'quotes.settings',
} as const

export const QuoteInvoiceOnAcceptSchema = z.enum([
  'always',
  'unlinked_only',
  'never',
])
export type QuoteInvoiceOnAccept = z.infer<typeof QuoteInvoiceOnAcceptSchema>

export const QuotesModuleSettingsSchema = z.object({
  /**
   * When accepting a quote auto-creates a DRAFT invoice:
   * - always: every accepted quote with a client entity
   * - unlinked_only: only quotes with no deal — deal-linked quotes bill
   *   through won → convert → contract instead (default)
   * - never: acceptance never creates an invoice
   */
  invoiceOnAccept: QuoteInvoiceOnAcceptSchema.default('unlinked_only'),
})

export type QuotesModuleSettings = z.infer<typeof QuotesModuleSettingsSchema>

export const getDefaultQuotesModuleSettings = (): QuotesModuleSettings =>
  QuotesModuleSettingsSchema.parse({})

/**
 * Parse a stored settings blob tolerantly: unknown fields are dropped,
 * missing fields fall back to defaults, and a malformed blob degrades to
 * all-defaults instead of throwing.
 */
export function parseQuotesModuleSettings(value: unknown): QuotesModuleSettings {
  const result = QuotesModuleSettingsSchema.safeParse(value ?? {})
  return result.success ? result.data : getDefaultQuotesModuleSettings()
}
